import { React, useState } from 'react';
import logo from '../assets/logo.svg';
import logout from '../assets/logout.svg';
import { LoadingOutlined } from '@ant-design/icons';
import { logoutUser } from '../services/apiservice';
import { removeUserDataFromBrowserStorage } from '../helper/_commonHelper';
import { useNavigate } from 'react-router-dom';
import { Spin, message, Button, Modal } from 'antd';

const Header = () => {
    const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
    const [logoutLoading, setLogoutLoading] = useState(false);
    const navigate = useNavigate();

    const showLogoutConfirmation = () => {
        setIsLogoutModalVisible(true);
    };

    const handleLogoutCancel = () => {
        setIsLogoutModalVisible(false);
    };

    const handleLogoutConfirm = async () => {
        setIsLogoutModalVisible(false);
        try {
            setLogoutLoading(true);
            const response = await logoutUser();
            if (response.status === 200) {
                removeUserDataFromBrowserStorage();
                navigate('/login', { replace: true });
            }
        } catch (error) {
            console.log('error', error);
            message.error('Logout failed. Please try again.');
        } finally {
            setLogoutLoading(false);
        }
    };
    return (
        <>
            <div className='head-section w-full z-10 flex justify-center items-center py-3 px-4 relative'>
                <img src={logo} alt='logo' className='max-w-44 md:max-w-48' />
                <Button
                    type='primary'
                    onClick={showLogoutConfirmation}
                    className='logout-button absolute right-4'
                >
                    {logoutLoading ? (
                        <LoadingOutlined style={{ color: '#1890ff' }} />
                    ) : (
                        <img
                            src={logout}
                            alt='Logout'
                            className='md:w-6 md:h-6'
                        />
                    )}
                </Button>
            </div>
            <Modal
                title='Confirm Logout'
                visible={isLogoutModalVisible}
                onOk={handleLogoutConfirm}
                onCancel={handleLogoutCancel}
                okText='Logout'
                cancelText='Cancel'
            >
                <p>Are you sure you want to logout?</p>
            </Modal>
        </>
    );
};

export default Header;
